export const DOWNLOAD_LIST_PAGE_SIZES = [10, 20] as const;

export type DownloadListPageSize = (typeof DOWNLOAD_LIST_PAGE_SIZES)[number];

export const DEFAULT_DOWNLOAD_LIST_PAGE_SIZE: DownloadListPageSize = 20;

export function normalizeDownloadListPageSize(value: number): DownloadListPageSize {
  if (value === 10 || value === 20) return value;
  return DEFAULT_DOWNLOAD_LIST_PAGE_SIZE;
}
